class FontScale {
  constructor() {
    this.applySavedFontScale();
    this.initToggle();
  }

  applySavedFontScale() {
    this.savedFontScale = this.getFontScaleInLocalStorage();

    if (this.savedFontScale !== null) {
      this.setFontScale(this.savedFontScale);
    }
  }

  getFontScaleInLocalStorage() {
    return localStorage.getItem("klarnachrichten-font-scale");
  }

  initToggle() {
    this.root = document.querySelector("#font-scale");
    this.overlay = document.querySelector("#font-scale-overlay");
    this.toggle = document.querySelector("#font-scale-toggle");
    this.range = document.querySelector("#font-scale-input");
    this.minus = document.querySelector("#font-scale-minus");
    this.plus = document.querySelector("#font-scale-plus");
    this.isOpen = false;

    const min = parseInt(this.range.getAttribute("min"));
    const max = parseInt(this.range.getAttribute("max"));

    // Apply saved value to range select
    if (this.savedFontScale) {
      this.range.value = this.savedFontScale;
    }

    // Toggle
    this.toggle.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });

    // Hide select - Escape
    document.addEventListener("keydown", (e) => {
      if (this.isOpen && e.key === "Escape") {
        this.close();
      }
    });

    // Hide select - Outside click
    document.addEventListener("click", (e) => {
      if (!this.isOpen) {
        return;
      }

      if (e.target.getAttribute("id") === "font-scale-backdrop") {
        this.close();
        return;
      }

      if (!e.target.closest("#font-scale")) {
        this.close();
      }
    });

    // Update font scale
    this.range.addEventListener("input", () => {
      this.setFontScale(this.range.value);
      this.minus.toggleAttribute("disabled", this.range.value <= min);
      this.plus.toggleAttribute("disabled", this.range.value >= max);
      window.klarnachrichten.trackMatomoEvent("change-font-scale", this.range.value);
    });

    // Decrease font size
    this.minus.addEventListener("click", () => {
      if (this.range.value <= min) {
        return;
      }
      this.range.value--;
      this.range.dispatchEvent(new Event("input"));
    });

    // Increase font size
    this.plus.addEventListener("click", () => {
      if (this.range.value >= max) {
        return;
      }
      this.range.value++;
      this.range.dispatchEvent(new Event("input"));
    });
  }

  open() {
    document.body.style.setProperty("overflow", "hidden");
    this.overlay.removeAttribute("inert");
    this.root.classList.add("open");
    this.isOpen = true;
    this.range.focus();
  }

  close() {
    document.body.style.removeProperty("overflow");
    this.overlay.setAttribute("inert", "");
    this.root.classList.remove("open");
    this.isOpen = false;
  }

  setFontScale(scale) {
    document.documentElement.setAttribute("data-font-scale", scale);
    localStorage.setItem("klarnachrichten-font-scale", scale);
  }
}

window.klarnachrichten.fontScale = new FontScale();
